export const transcripts = {
  comments: (params: { transcriptId: number }) =>
    ['transcript-comments', params] as const,

  entities: (params: { transcriptId: number }) =>
    ['transcript-entities', params] as const,

  highlights: (params: { transcriptId: number }) =>
    ['transcript-highlights', params] as const,

  tags: (params: { transcriptId: number; projectId?: number }) =>
    ['transcript-tags', params] as const,

  tagOverview: (params: { transcriptId: number; projectId: number }) =>
    ['transcript-tag-overview', params] as const,

  media: (params: { transcriptId: number }) =>
    ['transcript.media', params] as const,

  report: (params: { transcriptId: number; projectId?: number }) =>
    ['transcript-report', params] as const,

  tagSummariesCitations: (params: { transcriptId: number; tagId: number }) =>
    ['get:transcripts/conference-tags/summaries/citations', params] as const,

  tagsExport: (params: { transcriptId: number }) =>
    ['transcript-tags-export', params] as const,

  tagsSummaryExport: (params: { transcriptId: number }) =>
    ['transcript-tags-summary-export', params] as const,

  extractedData: (params: { transcriptId: number }) =>
    ['transcript-extracted-data', params] as const,
};
